import Axios from 'axios'
import { message } from 'antd'
const API_CODE = {
  SUCCESS: 200
}

const axiosIns = Axios.create({
  baseURL: '/api',
  withCredentials: true,
  timeout: 16000,
})

axiosIns.interceptors.response.use(response => {
  const { data } = response

  if(data.code === API_CODE.SUCCESS) {
    return Promise.resolve(data.data)
  } else {
    message.error(`${data.code}-${data.msg}`)
    return Promise.reject(`${data.code}-${data.msg}`)
  }
},
error => {
  message.error(error.message || '服务器开小差')
  return Promise.reject(error.message || '服务器开小差')
})


export default axiosIns
